export default __webpack_public_path__ + "static/media/handshake.a36bb902.webp";